import { useEffect } from 'react'
import 'antd/dist/antd.css'
import { useDispatch } from 'react-redux'
import { setUserInfo } from 'redux/actions'
import { ThemeProvider } from 'fronton-react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import styled from 'styled-components'
import GlobalStyles from 'shared/theme/GlobalStyles'
import { projectTheme } from 'shared/theme/projectTheme'
import { ConfigLoader } from 'redux/ConfigLoader'
import Routes from 'Routes'
import './app.scss'

const AppWrapper = styled.div`
    height: 100%;
`

/**
 * Инициализация кеша react-query.
 */
const queryClient = new QueryClient()

function App() {
    const dispatch = useDispatch()

    useEffect(() => {
        const token = localStorage.getItem('accessToken')

        if (token) {
            dispatch(setUserInfo(token))
        }
    }, [])

    return (
        <AppWrapper>
            <GlobalStyles theme={projectTheme} />
            <QueryClientProvider client={queryClient}>
                <div className="theme-provider-styles">
                    <ThemeProvider>
                        <ConfigLoader>
                            {(isLoading: boolean) =>
                                isLoading ? (
                                    <div>{'В процессе загрузки'}</div>
                                ) : (
                                    <Router>
                                        <Switch>
                                            <Routes />
                                        </Switch>
                                    </Router>
                                )
                            }
                        </ConfigLoader>
                    </ThemeProvider>
                </div>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </AppWrapper>
    )
}

export default App
